import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const registrationManagement = {
    major: {
        queryList: config => createAPI('/skillRecognition/bmgl/queryList', 'post', config),
        initCombo: config => createAPI('/skillRecognition/bmgl/initCombo', 'post', config),
        save: config => createAPI('/skillRecognition/bmgl/save', 'post', config),
        deleteById: config => createAPI('/skillRecognition/bmgl/del', 'post', config),
        releaseRecById: config => createAPI('/skillRecognition/bmgl/releaseRecById', 'post', config),
        queryById: config => createAPI('/skillRecognition/bmgl/queryById', 'post', config),
        queryKskcbById: config => createAPI('/skillRecognition/bmgl/queryKskcbById', 'post', config),
        queryKskcByKsbh: config => createAPI('/skillRecognition/bmgl/queryKskcByKsbh', 'post', config),
        queryXxmdListByKsbh: config => createAPI('/skillRecognition/bmgl/queryXxmdListByKsbh', 'post', config),
        queryStuList: config => createAPI('/skillRecognition/bmgl/queryStuList', 'post', config),
        saveKsbmb: config => createAPI('/skillRecognition/bmgl/saveKsbmb', 'post', config),
        queryXsbmByKsbh: config => createAPI('/skillRecognition/bmgl/queryXsbmByKsbh', 'post', config),
        saveXsbm: config => createAPI('/skillRecognition/bmgl/saveXsbm', 'post', config),
        submitXsbm: config => createAPI('/skillRecognition/bmgl/submitXsbm', 'post', config),
        upload: config => createAPI('/skillRecognition/bmgl/upload', 'post', config),
        uploadDwbm: config => createAPI('/skillRecognition/bmgl/uploadDwbm', 'post', config),
    },
};

export default registrationManagement;



// WEBPACK FOOTER //
// ./src/api/modules/registrationManagement.js